import { del, executeApp, get, post, put } from '@/utils/request'
import {
  WORKSPACE,
  WORKSPACE_SHARE_GROUP,
} from '@/api/defineRouting'

export function createWorkSpace<T = any>(
  data: { name: string; industry?: string[]; description?: string; grading_scale?: number },
) {
  return post<T>({
    url: '/agents-service/workspaces/create',
    data,
  })
}

export function updateWorkSpace<T = any>(
  data: any,
) {
  return put<T>({
    url: `/agents-service/workspaces/update/${data.workspace_id}`,
    data,
  })
}

export function updateWorkSpaceGradingScale<T = any>(
  data: any,
) {
  return post<T>({
    url: '/agents-service/workspaces/grading-scale-update',
    data,
  })
}

export function getDetailWorkSpace<T = any>(
  data: { workspace_id: number },
) {
  return get<T>({
    url: `/agents-service/workspaces/detail/${data.workspace_id}`,
  })
}

export function deleteWorkSpace<T = any>(
  data: { workspace_id: number },
) {
  return del<T>({
    url: `/agents-service/workspaces/delete/${data.workspace_id}`,
    data,
  })
}

export function getListWorkSpace<T = any>(
  data: any,
) {
  return get<T>({
    url: '/agents-service/workspaces/list',
    data,
  })
}

export function getListWorkSpaceShare<T = any>(
  data: { workspace_id: string; group_id: number },
) {
  // group_id ( 0: tất cả các nhóm, -1: user không có nhóm, -2: chỉ user có nhóm)
  return get<T>({
    url: `/agents-service/workspaces/emails-shared?workspaces_id=${data.workspace_id}&group_id=${data.group_id}`,
  })
}

export function createListWorkSpaceShare<T = any>(
  data: { workspace_id: string; email: string[] },
) {
  return post<T>({
    url: '/agents-service/workspaces/share',
    data,
  })
}

export function updateAccountRole<T = any>(
  id: string | number,
  data: any,
) {
  return put<T>({
    url: `/agents-service/workspaces/update_account_role/${id}`,
    data,
  })
}

export function deleteAccount<T = any>(
  id: string | number,
) {
  return del<T>({
    url: `/agents-service/workspaces/delete_account/${id}`,
  })
}

/**
 * Workspace Share Group
 */

export function createWorkspaceShareGroup<T = any>(data: any) {
  return executeApp<T>(WORKSPACE_SHARE_GROUP.CREATE, data, 'post',
  )
}

export function getListWorkspaceShareGroup<T = any>(data: any) {
  return executeApp<T>(WORKSPACE_SHARE_GROUP.LIST, data, 'post',
  )
}

export function detailWorkspaceShareGroup<T = any>(data: any) {
  return executeApp<T>(WORKSPACE_SHARE_GROUP.DETAIL, data, 'get',
  )
}

export function updateWorkspaceShareGroup<T = any>(data: any) {
  return executeApp<T>(WORKSPACE_SHARE_GROUP.UPDATE, data, 'put',
  )
}

export function deleteWorkspaceShareGroup<T = any>(data: any) {
  return executeApp<T>(WORKSPACE_SHARE_GROUP.DELETE, data, 'delete',
  )
}

export function assignGroupWorkspaceShareGroup<T = any>(data: any) {
  return executeApp<T>(WORKSPACE_SHARE_GROUP.ASSIGN_GROUP_FOR_STUDENTS, data, 'post',
  )
}

export function getListWorkspaceAdmin<T = any>(data: any) {
  return executeApp<T>(WORKSPACE.LIST_WORKSPACE_ADMIN, data, 'get',
  )
}

export function updateWorkspaceAdmin<T = any>(data: any) {
  return executeApp<T>(`${WORKSPACE.UPDATE_WORKSPACE_ADMIN}/${data.workspace_id}`, data, 'put',
  )
}

export function deleteWorkspaceAdmin<T = any>(data: any) {
  return executeApp<T>(`${WORKSPACE.DELETE_WORKSPACE_ADMIN}/${data.id}`, data, 'delete',
  )
}

export function shareAdmin<T = any>(data: any) {
  return executeApp<T>(WORKSPACE.SHARE_ADMIN, data, 'post',
  )
}

export function getApprovedAccount<T = any>(data: any) {
  return executeApp<T>(WORKSPACE.GET_APPROVED_ACCOUNT, data, 'get',
  )
}
export function updateApprovedAccount<T = any>(data: any) {
  return executeApp<T>(WORKSPACE.UPDATE_APPROVED_ACCOUNT, data, 'put',
  )
}

export function getWorkspacePending<T = any>() {
  return executeApp<T>(WORKSPACE.GET_WORKSPACE_PENDING, {}, 'get',
  )
}
export function deleteWorkspaceByAccount<T = any>(data: any) {
  return executeApp<T>(`${WORKSPACE.DELETE_WORKSPACE_BY_ACCOUNT}/${data.workspace_id}`, {}, 'delete',
  )
}
